/*----------------------------------------------------

	util.js

----------------------------------------------------*/

// Polyfill forEach for ES5
if(window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// is visible
function isVisible(obj){
  return obj.offsetWidth > 0 && obj.offsetHeight > 0;
}

// is in viewport
var isInViewport = function (elem) {
  var bounding = elem.getBoundingClientRect();
  return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

// cookies
function setCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString()
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function deleteCookie(name) {
  setCookie(name,"",-1);
}

// debounce
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}


/* dynamic loading
----------------------------------------------------------------------------------------------------*/

function loadScript(url){
  (function(document, tag) {
      var scriptTag = document.createElement(tag), // create a script tag
          firstScriptTag = document.getElementsByTagName(tag)[0]; // find the first script tag in the document
      scriptTag.src = url; // set the source of the script to your script
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
  }(document, 'script'));
}

function loadCSS(url){
  var head = document.getElementsByTagName('head')[0];
  var link  = document.createElement('link');
  link.rel  = 'stylesheet';
  link.type = 'text/css';
  link.href = url;
  head.appendChild(link);
}


/* JS / bubble links
----------------------------------------------------------------------------------------------------*/

(function() {
  
  'use strict';

  // Function to handle the click event
  var handleClickableClick = function(e) {
    if (e.target.tagName.toLowerCase() !== 'a') {
      e.preventDefault();

      var clickable = e.target.closest('[data-clickable]');
      if (clickable) {
        var destination_link = clickable.querySelector('a');
        if(destination_link){
          var destination = destination_link.getAttribute('href');
          if (destination) {
            if (e.ctrlKey || clickable.getAttribute('target') === '_blank' || destination_link.classList.contains('externalLink')) {
              window.open(destination, '_blank');
            } else {
              window.location.href = destination;
            }
          }
        }
      }
    }
  };

  // Attach the event listener to a parent element that exists before and after AJAX content insertion
  document.addEventListener('click', function(e) {
    var target = e.target;
    var isClickable = target.hasAttribute('data-clickable') || target.closest('[data-clickable]');
    if (isClickable) {
      handleClickableClick(e);
    }
  });

})();


/* external links
----------------------------------------------------------------------------------------------------*/

var links = document.links;

for(var i = 0, linksLength = links.length; i < linksLength; i++) {
  var href = links[i].getAttribute('href');
  if((links[i].hostname != window.location.hostname || 
    href.match('.pdf$') || 
    href.includes('user-profile') ||
    links[i].classList.contains('new-tab')) &&
    href !== 'javascript:void(0);'){
      links[i].target = '_blank';
  }
}


/* generic showhide
----------------------------------------------------------------------------------------------------*/

var showhide_links = document.querySelectorAll('[data-showhide],[data-showhidemobile]');

// For each
[].forEach.call(showhide_links, function(link){

  link.addEventListener('click', function(ev){

    // Prevent the default link behavior
    ev.preventDefault();
    ev.stopPropagation();

    var target = (link.dataset.showhide) ? document.querySelector(link.dataset.showhide) : document.querySelector(link.getAttribute('href'));

    // if nav check if is in viewport, for others check if visible
    // if((target.id == 'nav' && isInViewport(target)) || (target.id != 'nav' && isVisible(target))){
    if(isVisible(target)){
      target.classList.remove('show');
      target.classList.add('hide');
      setTimeout(() => {
        target.classList.remove('hide');
      },500);
    }else{
      closeShowHide(ev);
      target.classList.add('show');

      var child_links = target.querySelectorAll('a');
      [].forEach.call(child_links, function(cl){
        cl.addEventListener('click', function(ev){
          closeShowHide(target);
        });
      });

    }

  });

});


function closeShowHide(ev){
  var docclose = document.querySelectorAll('[data-docclose],[data-hidesiblings]');
  [].forEach.call(docclose, function(link){
    if(ev.target && isVisible(link) && ev.target !== link && !link.contains(ev.target)){
      link.classList.remove('show');
    }
  });
}

document.addEventListener('click', function(ev){
  closeShowHide(ev);
});
